import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Modules } from '@app/core/Enum';
import { ConfirmationList } from '@app/core/Models';
import {
  CommonService,
  NoteService,
} from '@app/core/Services';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent implements OnInit {
  confirmationList: ConfirmationList;
  id: Guid;
  noteData: any;
  modules = Modules;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    public commonService: CommonService,
    public noteService: NoteService,
  ) {}

  ngOnInit(): void {
    //do nothing
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
